import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_DETAILS } from "../App";
import { errorMessage } from "../utils/errorMessage";

/**
 * Where "Send Me My Results" in the confirmation email lands.
 *
 * A signed-out visitor's questionnaire results are no longer emailed to whatever
 * address was typed. The first email only asks the owner of that inbox to
 * confirm it; following the link is that confirmation, and this page asks the
 * server to send the results now that it knows whose inbox it is.
 */
const ConfirmResults = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState(token ? "sending" : "invalid");
  const [message, setMessage] = useState("");
  // Strict mode runs effects twice in development; one email is enough.
  const sent = useRef(false);

  useEffect(() => {
    if (!token || sent.current) return;
    sent.current = true;
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + "/confirmScoreEmail";
    axios
      .post(url, { token })
      .then(() => setState("sent"))
      .catch((err) => {
        setMessage(errorMessage(err, "We couldn't send your results just now. Please follow the link in your email again."));
        setState("failed");
      });
  }, [token]);

  return (
    <div className="notfound-page">
      <main className="notfound-main" aria-live="polite">
        {state === "sending" && (
          <>
            <h1>Sending your results…</h1>
            <p>This only takes a moment.</p>
          </>
        )}
        {state === "sent" && (
          <>
            <p className="notfound-code">Sent</p>
            <h1>Your results are on their way</h1>
            <p>Thanks for confirming your address. Your symptom score and what it means will arrive in your inbox in the next few minutes.</p>
            <div className="notfound-actions">
              <Link className="btn-filled" to="/signup">Get Started with Youro</Link>
              <Link className="notfound-secondary" to="/conditions">Back to conditions</Link>
            </div>
          </>
        )}
        {(state === "failed" || state === "invalid") && (
          <>
            <h1>We couldn't send your results</h1>
            <p>{state === "invalid" ? "This link is incomplete. Open it again from the email we sent you." : message}</p>
            <div className="notfound-actions">
              <Link className="btn-filled" to="/conditions">Take the questionnaire again</Link>
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default ConfirmResults;
